import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HomeIcon, SearchIcon, PlusIcon, BellIcon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function BottomNav() {
  const location = useLocation();
  const navItems = [{
    path: '/feed',
    icon: HomeIcon,
    label: 'Home'
  }, {
    path: '/discover',
    icon: SearchIcon,
    label: 'Discover'
  }, {
    path: '/upload',
    icon: PlusIcon,
    label: 'Upload',
    isCenter: true
  }, {
    path: '/notifications',
    icon: BellIcon,
    label: 'Inbox',
    badge: true
  }, {
    path: '/profile',
    icon: UserIcon,
    label: 'Profile'
  }];
  return <nav className="absolute bottom-0 left-0 right-0 h-[72px] bg-black/95 backdrop-blur-md border-t border-border z-50" data-id="element-113">
      <div className="flex items-stretch h-full" data-id="element-114">
        {navItems.map(item => {
        const isActive = location.pathname === item.path || item.path === '/feed' && location.pathname === '/';
        const Icon = item.icon;
        if (item.isCenter) {
          return <NavLink key={item.path} to={item.path} className="flex-1 flex items-center justify-center relative" aria-label={item.label} data-id="element-115">
                <motion.div whileTap={{
              scale: 0.92
            }} className="w-12 h-9 bg-primary rounded-xl flex items-center justify-center shadow-[0_4px_14px_rgba(255,212,0,0.35)] relative overflow-hidden" data-id="element-116">
                  {/* Subtle accent stripe behind plus */}
                  <span className="absolute inset-y-0 -left-1 w-3 bg-neonOrange/80" aria-hidden data-id="element-117" />
                  <PlusIcon size={22} className="text-black relative z-10" strokeWidth={3} data-id="element-118" />
                </motion.div>
              </NavLink>;
        }
        return <NavLink key={item.path} to={item.path} className="flex-1 flex flex-col items-center justify-center gap-1 relative" aria-label={item.label} data-id="element-119">
              {isActive && <motion.div layoutId="bottomNavIndicator" className="absolute top-0 w-8 h-0.5 bg-primary rounded-b-full" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-120" />}
              <div className="relative" data-id="element-121">
                <Icon size={22} className={`transition-colors duration-200 ${isActive ? 'text-primary' : 'text-softGray'}`} strokeWidth={isActive ? 2.5 : 2} fill={isActive ? 'currentColor' : 'none'} data-id="element-122" />
                {item.badge && <span className="absolute -top-1 -right-1.5 w-2 h-2 bg-neonOrange rounded-full ring-2 ring-black" data-id="element-123" />}
              </div>
              <span className={`text-[10px] font-medium transition-colors duration-200 ${isActive ? 'text-primary' : 'text-softGray'}`} data-id="element-124">
                {item.label}
              </span>
            </NavLink>;
      })}
      </div>
    </nav>;
}